import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

import SelectOffPath from '../../../Image/GrayDownArrow.png';

export default function SortMethodSelectBox(props) {
  const { isEdit, value, setValue } = props;

  const [isClicked, setIsClicked] = useState(false);
  
  const TotalRef = useRef();
  const SelectListRef = useRef();

  const options = ['asc', 'desc'];

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [onClickOutSide])
  
  // 선택된 데이터 표출 //
  function decideSelectedValue() {
    if (value === 'asc') return '오름차순';
    else return '내림차순';
  }

  // 선택지 텍스트 정리 //
  function decideOptionText(data) {
    if (data === 'asc') return '오름차순';
    else return '내림차순';
  }

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  function onClickOutSide(e) {
    if (TotalRef.current !== e.target && !TotalRef.current.contains(e.target)) {
      setIsClicked(false);
    }
  }

  // 셀렉트 박스 클릭시 //
  function onClickSelectBox() {
		if (!isEdit) return;

		if (isClicked) {
			setIsClicked(false);
		}
		else {
			setIsClicked(true);
		}
  }

  // 수업 선택시 //
  function onClickSelectList(data) {
    setValue(data);

    setIsClicked(false);
  }

  return (
    <SelectBoxWrapper ref={TotalRef}>
      <SeletedBox
        onClick={onClickSelectBox}
        cursor={isEdit ? 'pointer' : 'default'}
        isClicked={isClicked}>
          <SelectBoxTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover={isEdit ? 'pointer' : 'default'}>{decideSelectedValue()}</Text>
          </SelectBoxTextWrapper>
        {isEdit && <ArrowImage src={SelectOffPath} isClicked={isClicked}/>}
      </SeletedBox>
      <WillSelectList ref={SelectListRef} isClicked={isClicked}>
        {
          options.map((data, index) => (
            <SelectListTextWrapper 
              key={'CustomTag-' + index}
              isClicked={isClicked}
              onClick={() => onClickSelectList(data)}>
              {decideOptionText(data)}
            </SelectListTextWrapper>
          ))
        }
      </WillSelectList>
    </SelectBoxWrapper>
  )
}

const SelectBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;
`;

const SeletedBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 15px;

  width: calc(100% - 32px);
  height: calc(100% - 2px);

  border-radius: ${props => props.isClicked ? '20px 20px 0px 0px' : '30px'};
  border: 2px solid #CBCBCB;
  background-color: #2F2F32;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;

const ArrowImage = styled.img`
  width: 17px;
  height: 10px;

  transform: ${props => props.isClicked ? `rotate(-180deg)` : `rotate(0deg)`};

  transition: all 0.3s ease-in-out;
`;

const WillSelectList = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 100%;
  margin-top: -2px;

  width: calc(100% - 2px);
  height: ${props => props.isClicked ? `66px` : `0px`};

  border-radius: 0px 0px 20px 20px;
  border: ${props => props.isClicked ? `2px solid #CBCBCB` : `0px`};
  background-color: #2F2F32;

  z-index: 500;

	overflow: hidden;

	:hover {
		cursor: pointer;
	}

	&::-webkit-scrollbar {
		// width: 9px;
		width: 0px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}

  transition: all 0.3s ease-in-out;
`;

const SelectBoxTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 80%;
  height: 21px;

  gap: 4px;

  overflow: hidden;
`;

const SelectListTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 0px 10px;

  width: calc(100% - 20px);
  min-height: 34px;

  overflow: hidden;
  
  background-color: #2F2F32;

  font-family: Poppins-Medium;
  font-size: 14px;

  color: #FFFFFF;

  :hover {
    cursor: pointer;
    background-color: #4E8168;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;